export default [
    {
        num: 1,
        label: {
            en: 'New',
            et: 'Uus',
            ru: 'Новый',
            lv: "Jauns",
            lt: "Naujas",
            fi: "Uusi",
        },
        // icon:'request-state request-state--new',
        classData: 'request-state--new'
    },
    {
        num: 3,
        label: {
            en: 'Need to order',
            et: 'On vaja tellida',
            ru: 'Нужно заказать',
            lv: "Jāpasūta",
            lt: "Reikia užsakyti",
            fi: "Tilattava",
        },
        // icon:'request-state request-state--to-order',
        classData: 'request-state--to-order'
    },
    {
        num: 2,
        label: {
            en: 'Сanceled',
            et: 'Tühistatud',
            ru: 'Отменено',
            lv: "Atcelts",
            lt: "Atšaukta",
            fi: "Peruttu",
        },
        // icon:'request-state request-state--to-order',
        classData: 'request-state--сanceled'
    },
    {
        num: 4,
        label: {
            en: 'Ordered',
            et: 'Tellitud',
            ru: 'Заказано',
            lv: "Pasūtīts",
            lt: "Užsakyta",
            fi: "Tilattu",
        },
        // icon:'request-state request-state--ordered',
        classData: 'request-state--ordered'
    },
    {
        num: 5,
        label: {
            en: 'Waiting for delivery',
            et: 'Ootab kohaletoimetamist',
            ru: 'Ожидает доставки',
            lv: "Gaida piegādi",
            lt: "Laukiama pristatymo",
            fi: "Odottaa toimitusta",
        },
        // icon:'request-state request-state--waiting-delivery',
        classData: 'request-state--waiting-delivery'
    },
    {
        num: 6,
        label: {
            en: 'Need to deliver',
            et: 'Vaja kohale toimetada',
            ru: 'Нужно доставить',
            lv: "Jāpiegādā",
            lt: "Reikia pristatyti",
            fi: "Toimitettava",
        },
        // icon:'request-state request-state--need-to-deliver',
        classData: 'request-state--need-to-deliver'
    },
    {
        num: 7,
        label: {
            en: 'Delivered',
            et: 'Tarnitud',
            ru: 'Доставлено',
            lv: "Piegādāts",
            lt: "Pristatyta",
            fi: "Toimitettu",
        },
        // icon:'request-state request-state--delivered',
        classData: 'request-state--delivered'
    }
]